import { DragAndDrop, DragAndDropProps } from './DragAndDrop';
import { DragAndDropHandle } from './Handle';
import { DragAndDropItem } from './Item';

const DragAndDropWithStatics = DragAndDrop as typeof DragAndDrop & {
  Item: typeof DragAndDropItem;
  Handle: typeof DragAndDropHandle;
};

DragAndDropWithStatics.Item = DragAndDropItem;
DragAndDropWithStatics.Handle = DragAndDropHandle;

export { DragAndDropWithStatics as DragAndDrop };
export type { DragAndDropProps };
